import React, { ReactNode } from 'react';

type TNonAuthLayoutProps = {
  children: ReactNode;
};

const NonAuthLayout = ({ children }: TNonAuthLayoutProps) => {
  return (
    <React.Fragment>{children}</React.Fragment>
  );
};

export default NonAuthLayout;
